import type { FaireProductEntity } from "../../entity_types/product";

export const p_4bprnxq49z: FaireProductEntity = {
  token: "p_4bprnxq49z",
  type: "product",
  name: "Large Tote, Cherries",
  brandToken: "b_2io333ig7s",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/f1527cd055258ad7a23839e904c72bba3696dca4cf953fb56d8f020ae65e1b1f.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/125a0717b6b3becfeea30656ffa8ba0c193865ff16275d0f2cf4f49d80bb87fa.jpeg",
    "https://cdn.faire.com/fastly/190fe394fbf69984cae2c904f68ad09c5629add408752f9f1c6d46936dd919c7.jpeg",
    "https://cdn.faire.com/fastly/228fb67c2b412ea96b630b7d5bb8e41fc28efb280958c8e9709d4ba3ee297c4e.jpeg",
    "https://cdn.faire.com/fastly/6d7f21ad542556b05e106210f7e0235396e9417375e91ee8bdd4dc32f777f638.jpeg",
  ],
  priceDollars: 24.25,
  description:
    "Be the belle of the produce aisle. This super-roomy canvas tote features a photorealistic print that turns every grocery run, market trip, or casual outing into a moment worth showing off. Strong, stylish, and ready to carry all your essentials.\n\nFeatures\n\nDurable canvas construction\n\nPhotorealistic all-over print for standout style\n\nRoomy interior ideal for groceries, books, beach days, and more\n\nComfortable straps for easy carrying\n\nDesigned in Bando’s signature bold, joyful style\n\n\nIdeal For\n\nGift shops and lifestyle boutiques\n\nGrocery, market, and eco-friendly retailers\n\nStudents, shoppers, and everyday adventurers\n\nWholesale buyers seeking high-impact, functional totes",
  tags: [],
  msrpDollars: 48.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:27:24.747Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
